// Privacy policy content — displayed in the WebView sidebar.

export default function PrivacyPolicyTab() {
  return (
    <div className="space-y-6 animate-fade-up max-w-2xl">
      <div>
        <h3 className="font-display font-bold text-lg text-foreground">
          Privacy Policy
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Last updated: April 2026
        </p>
      </div>

      <div className="space-y-5 text-sm text-muted-foreground leading-relaxed">
        <section>
          <h4 className="font-display font-semibold text-foreground mb-2">
            What we collect
          </h4>
          <p>
            Jobily stores the profile information you provide — name, email,
            phone, address, work experience, education, and skills. This data is
            used exclusively to auto-fill job applications and generate cover
            letters on your behalf.
          </p>
          <p className="mt-3">
            We collect anonymous usage events (such as which features are used and
            how often) via Google Analytics 4 to improve the Extension. This data is
            anonymous — it is associated with a randomly generated ID, not your name
            or email. No personally identifiable information is sent to Google
            Analytics.
          </p>
        </section>

        <section>
          <h4 className="font-display font-semibold text-foreground mb-2">
            How we store it
          </h4>
          <p>
            Your data is encrypted and stored in a secure PostgreSQL database
            with Row Level Security (RLS) enabled. Only you can access your own
            data — not other users, not our team. Local data in the browser
            extension is stored in your browser&apos;s localStorage and never
            transmitted except to generate AI content.
          </p>
        </section>

        <section>
          <h4 className="font-display font-semibold text-foreground mb-2">
            AI processing
          </h4>
          <p>
            When you generate a cover letter or answer a question, your profile
            data and the job description are sent to our AI provider (Anthropic)
            to produce the content. This data is used only for that single
            generation — it is not stored by the AI provider or used for
            training.
          </p>
        </section>

        <section>
          <h4 className="font-display font-semibold text-foreground mb-2">
            Third parties
          </h4>
          <div className="overflow-x-auto">
            <table className="w-full text-xs border border-border rounded-lg overflow-hidden">
              <thead>
                <tr className="bg-muted/50 text-left">
                  <th className="p-2 font-semibold text-foreground">Service</th>
                  <th className="p-2 font-semibold text-foreground">Data</th>
                  <th className="p-2 font-semibold text-foreground">Purpose</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-border">
                  <td className="p-2 align-top">Anthropic (AI)</td>
                  <td className="p-2 align-top">Profile + job text for generation</td>
                  <td className="p-2 align-top">Cover letters and Q&amp;A</td>
                </tr>
                <tr className="border-t border-border">
                  <td className="p-2 align-top">Supabase</td>
                  <td className="p-2 align-top">Account and profile storage</td>
                  <td className="p-2 align-top">Authentication and sync</td>
                </tr>
                <tr className="border-t border-border">
                  <td className="p-2 align-top">Stripe</td>
                  <td className="p-2 align-top">Payment processing</td>
                  <td className="p-2 align-top">Subscriptions</td>
                </tr>
                <tr className="border-t border-border">
                  <td className="p-2 align-top">
                    <a
                      href="https://policies.google.com/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary hover:underline"
                    >
                      Google Analytics
                    </a>
                  </td>
                  <td className="p-2 align-top">
                    Anonymous event names and counts, random client ID, session ID
                  </td>
                  <td className="p-2 align-top">
                    Understand feature usage and improve the Extension
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h4 className="font-display font-semibold text-foreground mb-2">
            What we don&apos;t do
          </h4>
          <p>
            We never sell your personal information. We don&apos;t share your
            data with third parties for marketing. We don&apos;t track which
            websites you browse outside of Jobily. We don&apos;t use your data to
            train AI models.
          </p>
        </section>

        <section>
          <h4 className="font-display font-semibold text-foreground mb-2">
            Payments
          </h4>
          <p>
            Subscription payments are processed by Stripe. We never see or store
            your credit card details — Stripe handles all payment information
            directly.
          </p>
        </section>

        <section>
          <h4 className="font-display font-semibold text-foreground mb-2">
            Data deletion
          </h4>
          <p>
            You can delete your account and all associated data at any time by
            contacting support. Upon deletion, all profile data, applications,
            and stored resumes are permanently removed from our systems.
          </p>
        </section>

        <section>
          <h4 className="font-display font-semibold text-foreground mb-2">
            Contact
          </h4>
          <p>
            Questions about your privacy? Reach out at{" "}
            <a
              href="mailto:support@squareoneinternational.com"
              className="text-primary hover:underline"
            >
              support@squareoneinternational.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}
